import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { loadUserConsentsPermissions, loadUserConsentsPermissionsFailed, loadUserConsentsPermissionsSuccess } from "../actions/consents-permissions.actions";
import { ConsentsPermissionsService } from "../../services/consents-permissions/consents-permissions.service";
import { AppState } from "src/app/redux/app.state";
import { Store } from "@ngrx/store";
import { initializeUserResources } from "src/app/redux/actions/user-resources.actions";

@Injectable()
export class ConsentsPermissionsEffects {
	private actions$ = inject(Actions);
	private consentsPermissionsService = inject(ConsentsPermissionsService);
	private store = inject<Store<AppState>>(Store);


	// Load the User Tenants
	loadConsentsPermissions$ = createEffect(() => this.actions$.pipe(
		ofType(loadUserConsentsPermissions),
		switchMap(() =>
			this.consentsPermissionsService.loadUserConsentsPermissions().pipe(
				map(resp => {

					const uniqueIds = resp.data.permissions.map(consent => consent.identity.id).filter((value, index, self) => value && self.indexOf(value) === index);
					this.store.dispatch(initializeUserResources({ userIds: uniqueIds }));

					return loadUserConsentsPermissionsSuccess({ permissionsInfo: resp.data })
				}),
				catchError(async (error) => loadUserConsentsPermissionsFailed({ error: error }))
			)
		)
	));
}
